<div id="app-content-holder" class="page-layout carded fullwidth h-100-p"
    style="width:100%; min-width: 100%;max-width: 100%;">
    <!-- TOP BACKGROUND -->
    <div class="top-bg" [ngClass]="CssClass"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" fxFlex>

        <!-- HEADER -->
        <div fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutAlign.gt-xs="space-between center">

            <!-- PAGE TITLE -->
            <div class="logo my-12 m-sm-0"
                style="flex-direction: column;box-sizing: border-box;display: flex;place-content: center flex-start;align-items: flex-start;justify-content: center;align-content: center;flex-wrap: nowrap;">
                <span id="txtContentTitle" class="logo-text h1" style="color:white; margin-top:20px;">{{Title}}</span>
                <br *ngIf="showDescription" />
                <span *ngIf="showDescription" id="txtContentDescription" class=""
                    style="color:white; margin-bottom:10px">{{Description}}</span>
            </div>
            <!-- / PAGE TITLE -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT -->
        <div #content class="content-card mat-white-bg p-24">
            <ng-content></ng-content>
        </div>
        <!-- / CONTENT -->
    </div>
    <!-- / CENTER -->
</div>